function fetchNativeBridge() {
  return window.ww.nativeBridge
}
export default fetchNativeBridge
